
import { styles } from '@/shell/layout.styles'

export function NavSkeletons({ count }: { count: number }) {
  return (
    <div style={styles.navSection}>
      {Array.from({ length: count }, (_, i) => (
        <div key={i} style={styles.navSkeleton} />
      ))}
    </div>
  )
}

